export const Palette = {
    backgroundColorPrimary: "rgba(245, 247, 250, 1)",
    backgroundColorCard: "rgba(255, 255, 255, 1)",
    borderColorPrimary: "rgba(218, 223, 230, 1)",
    borderPrimary: `1px solid rgba(218, 223, 230, 1)`,
    textColorPrimary: "rgba(44, 62, 80, 1)",
    textColorError: "rgba(231, 76, 60, 1)",
    textColorWarning: "rgba(255, 141, 0, 1)",
    textColorPrimaryContrast: "rgba(255, 255, 255, 1)",
    textColorSecondary: "rgba(127, 143, 164, 1)",
    leftPanelItemBackgroundHover: "rgba(245, 245, 245, 1)",
    leftPanelItemBackgroundSelected: "rgba(235, 235, 235, 1)",
    leftPanelItemBackgroundHoverTransparent: "rgba(245, 245, 245, 0)",
    leftPanelItemBackgroundSelectedTransparent: "rgba(235, 235, 235, 0)",
    btnPrimary: "rgba(74, 144, 226, 1)",
    btnFillPrimaryHover: "rgb(54, 134, 224)",
    btnFillPrimaryActive: "rgb(30, 119, 221)",

    btnSecondary: "rgba(127, 143, 164, 1)",
    btnRemove: "rgba(231, 76, 60, 1)",
    btnDisabled: "rgba(193, 193, 193, 1)",
    btnPrimaryHover: "rgba(53, 122, 189, 0.13)",
    btnSecondaryHover: "rgba(127, 143, 164, 0.13)",
    btnRemoveHover: "rgba(192, 57, 43, 0.13)",
    btnPrimaryActive: "rgba(44, 90, 138, 0.07)",
    btnSecondaryActive: "rgba(127, 143, 164, 0.07)",
    btnRemoveActive: "rgba(169, 50, 38, 0.07)",
    btnOAuthBackground: "rgb(255, 255, 255)",
    btnOAuthBackgroundHover: "rgba(235, 235, 235, 0.85)",
    btnOAuthBackgroundActive: "eaf2fb",
    btnOAuthText: "#3c4043",
    btnOAuthBorder: "#dadce0",
}

export const ChartsPaletteIndex = [
    '#4A90E2',
    '#ff8d00',
    '#FFCE56',
    '#4BC0C0',
    '#9966FF',
    '#FF6384',
    '#E6B0AA',
    '#A3E4D7',
    '#D4AC0D',
    '#2E86C1'
];

export const BoxShadow = "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)";

export const Sizes = {
    pageTitle: "1.5rem",
    pageSecondTitle: "1.25rem",
    pageThirdTitle: "1.1rem",

    textLogo: "1.1rem",
    icon: "1.3rem",
    textPrimary: "0.875rem",
    textSecondary: "0.75rem",
}


export const BaseLeftPanelItemSx = {
    borderRadius: "0 4px 4px 0",
    ":hover": {
        background: Palette.leftPanelItemBackgroundHover,
        "& .gradient-box": {
            background: `linear-gradient(90deg, ${Palette.leftPanelItemBackgroundHoverTransparent} 0%, ${Palette.leftPanelItemBackgroundHover} 100%)`,
        }
    },
    "&.Mui-selected": {
        background: Palette.leftPanelItemBackgroundSelected,
        "& .gradient-box": {
            background: `linear-gradient(90deg,  ${Palette.leftPanelItemBackgroundSelectedTransparent} 0%,  ${Palette.leftPanelItemBackgroundSelected} 100%)`,
        },
        "&:hover": {
            background: Palette.leftPanelItemBackgroundSelected,
            "& .gradient-box": {
                background: `linear-gradient(90deg,  ${Palette.leftPanelItemBackgroundSelectedTransparent} 0%,  ${Palette.leftPanelItemBackgroundSelected} 100%)`,
            }
        }
    }
};